import React from "react"
import autobind from "class-autobind"
import { Table, TableRow, TableBody } from "material-ui"
import { grey500 } from "material-ui/styles/colors"
interface IProps {
    items: any[]
    dragDropRowId: string
    leftSideWidth: number
    rightSideWidth: number
    handleDrag(moveUp: number): void
    handleDrop(): void
    handleCancleDragDrop(): void
}
interface IState {
    positionX: number
    positionY: number
    mousePositionX: number
    mousePositionY: number
    isDraging: boolean
}

export default class DragDropRow extends React.Component<IProps, IState> {
    private initPositionY
    constructor(props: IProps) {
        super(props)
        this.state = {
            positionX: 0,
            positionY: 0,
            mousePositionX: 0,
            mousePositionY: 0,
            isDraging: false,
        }
        autobind(this);
    }

    componentDidMount() {
        this.handleCaptureDragDropRow(this.props)
        window.addEventListener("mousemove", this.handleMouseMoveInWindow)
        window.addEventListener("mouseup", this.handleMouseUpInWindow)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.dragDropRowId !== nextProps.dragDropRowId &&
            this.handleCaptureDragDropRow(nextProps)
    }

    componentWillUnmount() {
        window.removeEventListener("mousemove", this.handleMouseMoveInWindow)
        window.removeEventListener("mouseup", this.handleMouseUpInWindow)
    }

    handleMouseMoveInWindow(e) {
        this.state.isDraging &&
            this.setState({
                positionX: this.state.positionX - (this.state.mousePositionX - e.clientX),
                positionY: this.state.positionY - (this.state.mousePositionY - e.clientY),
                mousePositionX: e.clientX,
                mousePositionY: e.clientY,
            }, () =>
                this.handleDarging()
            )
    }

    handleDarging() {
        const diffRow = Math.round((this.initPositionY - this.state.positionY) / 50)
        if (diffRow === 0) return
        const dragDropItemIndexOf = this.props.items.findIndex(item => item.Id === this.props.dragDropRowId)
        if (dragDropItemIndexOf === 0 && diffRow > 0) return
        if (dragDropItemIndexOf === this.props.items.length - 1 && diffRow < 0) return
        this.initPositionY = this.initPositionY - diffRow * 50
        this.props.handleDrag(diffRow > 0 ? 1 : -1)
    }

    handleMouseUpInWindow() {
        this.state.isDraging ?
            this.props.handleDrop() :
            this.props.handleCancleDragDrop()
    }

    handleCaptureDragDropRow(props: IProps) {
        const scheduleMoveItemCoordinateRect = document.getElementById("ScheduleMoveItemCoordinate").getBoundingClientRect()
        const leftRect = document.getElementById(`left_${props.dragDropRowId}`).getBoundingClientRect()
        this.initPositionY = leftRect.top - scheduleMoveItemCoordinateRect.top
        this.setState({ positionX: leftRect.left - scheduleMoveItemCoordinateRect.left, positionY: this.initPositionY })
        document.getElementById("LeftDragDropItem").innerHTML = document.getElementById(`left_${props.dragDropRowId}`).innerHTML
        document.getElementById("RightDragDropItem").innerHTML = document.getElementById(`right_${props.dragDropRowId}`).innerHTML
        document.getElementById("DragDropItemMask").style.width = `${document.getElementById("DragDropItem").clientWidth}px`
        document.getElementById("DragDropItemMask").style.height = `${document.getElementById("DragDropItem").clientHeight}px`
    }

    render() {
        return (
            <div style={{ position: "absolute", top: this.state.positionY, left: this.state.positionX, zIndex: 5000 }}>
                <div
                    id="DragDropItemMask"
                    style={{ position: "absolute", zIndex: 100, cursor: "move", backgroundColor: grey500, opacity: 0.1 }}
                    onMouseDown={(e) => {
                        e.stopPropagation()
                        if (e.nativeEvent.button === 2) return
                        this.setState({
                            isDraging: true,
                            mousePositionX: e.clientX,
                            mousePositionY: e.clientY
                        })
                    }}
                />
                <div
                    id="DragDropItem"
                    style={{ display: "flex" }}
                >
                    <div style={{ width: this.props.leftSideWidth }}>
                        <Table>
                            <TableBody>
                                <TableRow
                                    id="LeftDragDropItem"
                                    style={{ borderTop: "1px solid rgb(224, 224, 224)", borderBottom: "1px solid rgb(224, 224, 224)" }}
                                />
                            </TableBody>
                        </Table>
                    </div>
                    <div style={{ width: this.props.rightSideWidth }}>
                        <Table>
                            <TableBody>
                                <TableRow
                                    id="RightDragDropItem"
                                    style={{ border: "1px solid rgb(224, 224, 224)" }}
                                />
                            </TableBody>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}